/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Network_Vehicles_TabInputs */

const fr_network_vehicles_tab = /** @type {(inputs: Network_Vehicles_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Véhicules`)
};

const en_network_vehicles_tab = /** @type {(inputs: Network_Vehicles_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vehicles`)
};

/**
* | output |
* | --- |
* | "Vehicles" |
*
* @param {Network_Vehicles_TabInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const network_vehicles_tab = /** @type {((inputs?: Network_Vehicles_TabInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Network_Vehicles_TabInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_network_vehicles_tab(inputs)
	return en_network_vehicles_tab(inputs)
});